
<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-9">
          <div class="auth-full-bg">
            <div class="w-100">
              <video class="bg-image" loop muted autoplay>
                <source src="../../assets/video/login.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
        <!-- end col -->

        <!-- LOGIN SECTION -->
        <div class="col-xl-3">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100 mt-4">
                <div class="text-center">
                  <router-link to="/" class="d-block auth-logo">
                    <img src="@/assets/images/logo.png" alt="" height="18" class="auth-logo-dark" />
                    <img src="@/assets/images/logo.png" alt="" style="width: 60%" />
                  </router-link>
                </div>
                <div class="my-auto mt-1">
                  <div class="text-center">
                    <h2 class="text-primary">ATMS</h2>
                    <p class="text-muted">Sign In</p>
                    <small class="text-muted">Advanced Traffic Management System</small>
                  </div>
                  <hr />
                  <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{ authError }}</b-alert>

                  <div v-if="notification.message" :class="'alert ' + notification.type">
                    {{ notification.message }}
                  </div>
                  <div class="mt-4">
                    <b-form @submit.prevent="tryToLogIn">
                      <b-form-group class="mb-3" id="username-inp-group" label="Username" label-for="username-inp">
                        <b-form-input id="username-inp" v-model="username" type="text" placeholder="Enter Username"
                          :class="{
                            'is-invalid': submitted && $v.username.$error,
                          }"></b-form-input>
                        <div v-if="submitted && $v.username.$error" class="invalid-feedback">
                          <span v-if="!$v.username.required">Username is required.</span>
                        </div>
                      </b-form-group>
                      <b-form-group class="mb-3" id="password-inp-group" label="Password" label-for="password-inp">
                        <b-form-input id="password-inp" v-model="password" :type="checked ? 'text' : 'password'"
                          placeholder="Enter password" :class="{
                            'is-invalid': submitted && $v.password.$error,
                          }"></b-form-input>
                        <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                          Password is required.
                        </div>
                      </b-form-group>

                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="password-check" v-model="checked" />
                        <label class="form-check-label" for="password-check">
                          Show Password
                        </label>
                      </div>

                      <Loader class="mt-3">
                        <div class="mt-3 d-grid">
                          <b-button type="submit" variant="primary">
                            Log In
                          </b-button>
                        </div>
                      </Loader>

                      <!-- <div class="mt-4 text-center">
                        <h5 class="font-size-14 mb-3">Sign in with</h5>

                        <ul class="list-inline">
                          <li class="list-inline-item">
                            <a
                              href="javascript::void()"
                              class="
                                social-list-item
                                bg-primary
                                text-white
                                border-primary
                              "
                            >
                              <i class="mdi mdi-facebook"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a
                              href="javascript::void()"
                              class="
                                social-list-item
                                bg-info
                                text-white
                                border-info
                              "
                            >
                              <i class="mdi mdi-twitter"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a
                              href="javascript::void()"
                              class="
                                social-list-item
                                bg-danger
                                text-white
                                border-danger
                              "
                            >
                              <i class="mdi mdi-google"></i>
                            </a>
                          </li>
                        </ul>
                      </div> -->
                    </b-form>
                    <!-- <div class="mt-5 text-center">
                      <p>
                        Don't have an account ?
                        <router-link
                          to="/auth/register-2"
                          class="fw-medium text-primary"
                        >
                          Signup now
                        </router-link>
                      </p>
                    </div> -->
                  </div>
                </div>

                <div class="mt-5 mt-md-5 text-center">
                  <p class="mb-0">
                    © {{ new Date().getFullYear() }}. ATMS.<br />
                    National Highways Authority of India.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end container-fluid -->
  </div>
</template>

<script>
import { authMethods, notificationMethods } from "@/state/helpers";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/widgets/loader.vue";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import Swal from 'sweetalert2'

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
  },
  data () {
    return {
      username: "",
      password: "",
      submitted: false,
      authError: null,
      isAuthError: false,
      checked: false
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("auth", ["status"]),
    notification () {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted () {
    this.changeLoaderValue(false);
    // this.changeLoaderValue(true);
    document.body.classList.add("auth-body-bg");
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    ...mapActions("layout", ["changeLoaderValue"]),

    async tryToLogIn () {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const { username, password } = this;
        if (username && password) {
          try {
            this.changeLoaderValue(true);
            await this.login({
              username,
              password,
            });
            this.submitted = false;
            this.changeLoaderValue(false);
          } catch (e) {
            this.changeLoaderValue(false);
            Swal.fire({
              icon: 'error',
              title: e.response.data.message,
              timer: 3000,
              showCancelButton: false,
              showConfirmButton: false
            })
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
  text-align: center;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}

.bg-image {
  // border-radius: 20px 20px 20px 20px;
  width: 100;
  height: 120vh;
  max-width: 100%;
  max-height: 100vh;
  margin: auto;
  object-fit: cover;
  opacity: 0.7;
  -webkit-filter: brightness(90%);
}

.bg-overlay {
  opacity: 0.7;
}
</style>